import { render, staticRenderFns } from "./Supplier2FA.vue?vue&type=template&id=b5404cb6"
import script from "./Supplier2FA.vue?vue&type=script&lang=js"
export * from "./Supplier2FA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports